<template>
  <Card class="activity-card">
    <div slot="title" class="title-row">
      <span><Icon type="ios-flame" color="#ff6b35" /> 灶火心法卡池</span>
      <Button size="small" type="text" icon="md-refresh" :loading="loading" @click="refresh">刷新</Button>
    </div>

    <Alert type="warning" show-icon>
      固定材料十连抽，抽取结果立即发放。第10次及其倍数保底绝品，第50次及其倍数保底灵宝。
    </Alert>

    <div class="draw-layout">
      <div class="draw-panel">
        <h3>选择心法范围</h3>
        <RadioGroup v-model="attributeScope" type="button" class="scope-group">
          <Radio label="FORCE"><Icon type="ios-flash" /> 力道</Radio>
          <Radio label="SPIRIT"><Icon type="ios-water" /> 灵力</Radio>
        </RadioGroup>

        <div class="material-box">
          <div class="material-icon"><Icon type="ios-diamond" /></div>
          <div>
            <strong>{{ materialName }}</strong>
            <p>拥有 {{ materialCount }} 个，每次十连消耗 {{ materialCost }} 个</p>
          </div>
        </div>

        <Button type="primary" size="large" long :loading="drawing" :disabled="!canDraw" @click="draw">
          <Icon type="ios-flame" /> 立即十连抽
        </Button>
        <p v-if="!canDraw" class="empty-hint">材料不足，无法抽取</p>
      </div>

      <div class="pity-panel">
        <h3>卡池进度</h3>
        <div class="pity-row">
          <span>累计抽取</span><strong>{{ totalDrawCount }}</strong>
        </div>
        <div class="pity-row">
          <span>距绝品保底</span><strong>{{ drawsToJuepin }} 抽</strong>
        </div>
        <div class="pity-row">
          <span>距灵宝保底</span><strong>{{ drawsToLingbao }} 抽</strong>
        </div>
        <Divider />
        <p class="scope-note">当前范围：{{ scopeName }}</p>
        <p class="scope-note">生成的属性和技能强化会严格匹配所选范围。</p>
      </div>
    </div>

    <Divider>最近抽取</Divider>
    <div v-if="history.length" class="history-list">
      <div v-for="record in history" :key="record.drawId" class="history-item">
        <div>
          <strong>{{ record.attributeScope === 'FORCE' ? '力道' : '灵力' }}十连</strong>
          <span class="history-time">{{ record.createTime }}</span>
        </div>
        <div class="history-summary">
          第 {{ record.drawCountStart }} - {{ record.drawCountEnd }} 抽
          <Tag v-for="reward in parseRewards(record.rewardJson)" :key="reward.instanceId" :color="rewardColor(reward.quality)">
            {{ reward.qualityName }} {{ reward.xinfaName }}
          </Tag>
        </div>
      </div>
    </div>
    <div v-else class="empty-history">暂无抽取记录</div>

    <Modal v-model="showResult" title="十连抽取结果" width="640" :mask-closable="false">
      <div class="result-head">
        <span>{{ resultScopeName }}心法</span>
        <span>第 {{ result.drawCountStart }} - {{ result.drawCountEnd }} 抽</span>
      </div>
      <div class="result-grid">
        <div v-for="reward in result.rewards || []" :key="reward.instanceId" class="result-item">
          <Tag :color="rewardColor(reward.quality)">{{ reward.qualityName }}</Tag>
          <strong>{{ reward.xinfaName }}</strong>
          <small>已直接生成，可在野外心法中查看</small>
        </div>
      </div>
      <div slot="footer"><Button type="primary" @click="showResult = false">确定</Button></div>
    </Modal>
  </Card>
</template>

<script>
export default {
  name: 'hearthActivity',
  data () {
    return {
      attributeScope: 'FORCE',
      materialId: '42045',
      materialName: '上品玄霜晶核',
      materialCount: 0,
      materialCost: 10,
      totalDrawCount: 0,
      drawsToJuepin: 10,
      drawsToLingbao: 50,
      history: [],
      result: { rewards: [] },
      showResult: false,
      loading: false,
      drawing: false
    }
  },
  computed: {
    canDraw () {
      return this.materialCount >= this.materialCost && !this.drawing
    },
    scopeName () {
      return this.attributeScope === 'FORCE' ? '力道' : '灵力'
    },
    resultScopeName () {
      return this.result.attributeScope === 'FORCE' ? '力道' : '灵力'
    }
  },
  methods: {
    charaId () {
      const value = `; ${document.cookie}`
      const parts = value.split('; charaId=')
      return parts.length === 2 ? parts.pop().split(';').shift() : ''
    },
    async refresh () {
      this.loading = true
      try {
        const [status, history] = await Promise.all([
          this.$http.get('/gameActivity/getHearthStatus', { params: { charaId: this.charaId() } }),
          this.$http.get('/gameActivity/getHearthHistory', { params: { charaId: this.charaId() } })
        ])
        if (status.data.status === 200) {
          const data = status.data.data || {}
          this.materialId = data.materialItemId || this.materialId
          this.materialName = data.materialItemName || this.materialName
          this.materialCount = data.materialCount || 0
          this.materialCost = (data.materialPerPull || 1) * (data.pullsPerRequest || 10)
          this.totalDrawCount = data.totalDrawCount || 0
          this.drawsToJuepin = data.drawsToJuepin || 10
          this.drawsToLingbao = data.drawsToLingbao || 50
        }
        if (history.data.status === 200) this.history = history.data.data || []
      } catch (error) {
        this.$Message.error('灶火数据刷新失败')
      } finally {
        this.loading = false
      }
    },
    async draw () {
      if (!this.canDraw) return
      this.drawing = true
      try {
        const response = await this.$http.post('/gameActivity/drawWildXinfa', {
          charaId: this.charaId(),
          drawType: 'TEN',
          attributeScope: this.attributeScope
        })
        if (response.data.status !== 200) {
          this.$Message.error(response.data.msg || '抽取失败')
          return
        }
        this.result = response.data.data || { rewards: [] }
        this.showResult = true
        await this.refresh()
      } catch (error) {
        this.$Message.error('抽取失败')
      } finally {
        this.drawing = false
      }
    },
    parseRewards (json) {
      if (!json) return []
      if (Array.isArray(json)) return json
      try { return JSON.parse(json) || [] } catch (error) { return [] }
    },
    rewardColor (quality) {
      return { 1: 'blue', 2: 'purple', 3: 'gold' }[quality] || 'default'
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style scoped>
.activity-card { margin: 20px; }
.title-row { display: flex; align-items: center; justify-content: space-between; }
.draw-layout { display: flex; gap: 32px; margin-top: 24px; }
.draw-panel, .pity-panel { flex: 1; padding: 20px; border: 1px solid #e8eaec; border-radius: 6px; }
.scope-group { margin: 16px 0 22px; }
.material-box { display: flex; align-items: center; gap: 14px; padding: 16px; margin-bottom: 20px; background: #fff8ee; border: 1px solid #ffe1b8; border-radius: 6px; }
.material-icon { color: #801dae; font-size: 32px; }
.material-box p { margin: 6px 0 0; color: #808695; }
.empty-hint { color: #ed4014; text-align: center; }
.pity-row { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #f0f0f0; }
.pity-row strong { color: #ff6b35; }
.scope-note { color: #808695; line-height: 1.7; }
.history-item { padding: 14px 0; border-bottom: 1px solid #e8eaec; }
.history-time { margin-left: 12px; color: #9ea7b4; font-size: 12px; }
.history-summary { margin-top: 8px; color: #808695; }
.history-summary .ivu-tag { margin-left: 8px; margin-top: 4px; }
.empty-history { padding: 30px; color: #9ea7b4; text-align: center; }
.result-head { display: flex; justify-content: space-between; margin-bottom: 16px; color: #808695; }
.result-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
.result-item { display: flex; flex-direction: column; gap: 6px; padding: 12px; border: 1px solid #e8eaec; border-radius: 6px; }
.result-item small { color: #9ea7b4; }
@media (max-width: 700px) {
  .activity-card { margin: 8px; }
  .draw-layout { flex-direction: column; gap: 14px; }
  .result-grid { grid-template-columns: 1fr; }
}
</style>



// WEBPACK FOOTER //
// src/components/hearthActivity.vue